var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"items":_vm.timezones,"outlined":"","label":_vm.$t('timezone'),"dense":"","item-value":"tzCode","item-text":"label","return-object":""},on:{"change":_vm.emitChange},model:{value:(_vm.timezone),callback:function ($$v) {_vm.timezone=$$v},expression:"timezone"}})
}
var staticRenderFns = []

export { render, staticRenderFns }